const goodsDetail = resolve => require(['@/pages/goods/sells/detail/index'], resolve);
const nextEdit = resolve => require(['@/pages/goods/sells/detail/nextEdit'], resolve)
const goodsDetailCustomized = resolve => require(['@/pages/goods/sells/detailCustomized/index'], resolve); // 定制商品详情
const customizedNextedit = resolve => require(['@/pages/goods/sells/detailCustomized/nextEdit'], resolve)

const storebrand = resolve => require(['@/pages/goods/sells'], resolve);
const brand = resolve => require(['@/pages/goods/brand'], resolve);
const spuindex = resolve => require(['@/pages/goods/goodTpl/spuindex'], resolve);
const spulist = resolve => require(['@/pages/goods/goodTpl/spulist'], resolve);
const goodstpl = resolve => require(['@/pages/goods/goodTpl'], resolve);
const bfcategory = resolve => require(['@/pages/goods/bfcategory'], resolve);
const addBrand = resolve => require(['@/pages/goods/brand/addBrand'], resolve);
const goodsSearch = resolve => require(['@/pages/goods/goodsSearch/index'], resolve);
const ageManagement = resolve => require(['@/pages/goods/ageManagement'], resolve);
const configDetail = resolve => require(['@/pages/goods/goodsDetailEntryConfig/configDetails'], resolve);
const goodsDetailEntryConfig = resolve => require(['@/pages/goods/goodsDetailEntryConfig'], resolve);
const addConfig = resolve => require(['@/pages/goods/goodsDetailEntryConfig/addConfig'], resolve);
export default [
    /*****************商品管理**************/
    {
        path: "/ageManagement",
        name: "适用年龄管理",
        component: ageManagement
    },
    //前台类目管理
    {
        path: "/bfcategory",
        name: "前台类目管理",
        component: bfcategory
    },
    //商品模板管理
    {
        path: "/goodstpl",
        name: "商品模板管理",
        component: goodstpl
    },

    /*商品管理模板下路由开始*/
    {
        path: "/goodstpl/spulist",
        name: "选择类目",
        component: spulist
    },
    {
        path: "/goodstpl/spuindex/:type/:id",
        name: "spu",
        component: spuindex
    },
    /*商品管理模板下路由结束*/
    //品牌管理
    {
        path: "/brand",
        name: "品牌管理",
        component: brand
    },
    {
        path: "/addBrand",
        name: "添加品牌",
        component: addBrand
    },
    //商家商品管理
    {
        path: "/storebrand",
        name: "商家商品管理",
        component: storebrand,
        meta: {
            keepAlive: true
        }
    },
    /*商家商品管理下路由开始*/
    {
        path: '/storebrand/nextedit',
        component: nextEdit
    },
    {
        path: "/storebrand/goodsDetail",
        name: "商品详情",
        component: goodsDetail
            /*商家商品管理下路由结束*/
    },
    // 定制商品开始
    {
        path: '/storebrand/customizedNextedit',
        component: customizedNextedit
    },
    {
        path: "/storebrand/goodsDetailCustomized",
        name: "定制商品详情",
        component: goodsDetailCustomized
            /*商家定制商品管理下路由结束*/
    },
    {
        path: "/store/goodsSearch",
        name: "商品搜索管理",
        component: goodsSearch
            /*商品搜索管理*/
    },
    // 商品详情入口配置管理 路由
    {
        path: "/goodsDetailEntryConfig",
        name: "商品详情入口配置管理",
        component: goodsDetailEntryConfig
    },
    {
        path: "/configDetail/:id",
        name: "查看配置",
        component: configDetail
    },
    {
        path: "/addConfig/:id",
        name: "新增或编辑配置",
        component: addConfig
    }
]